import type React from 'react';
import { Link } from 'react-router-dom';

interface FeatureCardProps {
  title: string;
  description: string;
  link: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, link }) => (
  <Link
    to={link}
    className="group bg-white rounded-lg p-6 mb-6 md:mb-0 flex flex-col justify-between cursor-pointer shadow-xl hover:bg-accent-50 hover:shadow-2xl transition duration-300"
  >
    <div>
      <h3 className="text-xl font-semibold mb-4">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
    </div>
    <span className="text-gray-600 hidden opacity-0 group-hover:opacity-100 md:inline-block py-2 px-4 rounded-sm hover:bg-iseldaAccent-700 transition duration-300 text-center">
      Meer informatie
    </span>
  </Link>
);

const Services = () => (
  <div className="max-w-6xl w-full px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-8">Aanbod</h2>
    </div>

    <div className="grid md:grid-cols-2 gap-8">
      <FeatureCard
        title="Individuele therapie"
        description="Krijg inzicht in je emoties en patronen. Werk aan een positiever zelfbeeld en ontdek hoe je sterker in het leven kunt staan."
        link="/therapie/#individueel"
      />
      <FeatureCard
        title="Relatie therapie"
        description="Relatie therapie helpt bij het herstellen van emotionele verbinding. Samen ontdekken we waar jullie vastlopen, versterken we veiligheid en bouwen we aan vertrouwen en intimiteit."
        link="/therapie/#relatie"
      />
      <FeatureCard
        title="Gezinstherapie"
        description="We onderzoeken de dynamiek binnen jullie gezin, doorbreken vaste patronen en versterken communicatie. Zo werken we aan meer verbinding, waar iedereen zich gezien en gesteund voelt."
        link="/therapie/#systeem"
      />
      <FeatureCard
        title="Supervisie"
        description="Supervisie is een plek waar je welkom bent met alles wat je tegenkomt in je werk. We onderzoeken samen wat er gebeurt in het contact met je cliënten en hoe dat bij jou van binnen voelbaar is. In een veilige en betrokken sfeer ontstaat ruimte om te vertragen, te reflecteren en te groeien, zodat je met meer vertrouwen en stevigheid aanwezig kunt zijn in de therapiekamer."
        link="/supervisie"
      />
    </div>
  </div>
);

export default Services;
